export default "assets/images/icons/entity-localisation-a9b85110.svg";